(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/play_desktop.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/play_desktop.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Play = Marionette.View.extend({
    regions: {
      coupon: '.maltipset-coupon',
      betslip: '#betslip-wrapper',
      statContainer: '.maltips-stat-container',
      drawSelector: '#drawChooser',
      game: '#game'
    },
    className: 'maltipset-play',
    template: function() {
      if (
        svs.maltipset.collections.draws &&
        svs.maltipset.collections.draws.any()
      ) {
        var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
        var showWideCoupon =
            !coupon.isMOrRSystem() && !coupon.get('xpertBaseRowMode');
        return svs.maltipset.templates.play({ showWideCoupon: showWideCoupon });
      }
      return svs.maltipset.templates.play();
    },
    initProductBase: function() {
      var self = this;
      var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
      var showWideCoupon =
            !coupon.isMOrRSystem() && !coupon.get('xpertBaseRowMode');
      this.listenTo(
        coupon,
        'change:selectedMatch',
        this.showStatsForMatch,
        this
      );
      this.listenTo(
        coupon,
        'change:system change:xpertBaseRowMode stopBaseRowEdit',
        this.changeCouponWidth,
        this
      );
      this.bigstatController = new svs.maltipset.controllers.BigStatController();

      if (svs.maltipset.views.coupon) {
        svs.maltipset.views.coupon.dispose();
      }
      svs.maltipset.views.coupon = new svs.maltipset.views.Coupon({
        model: coupon
      });
      var productBase = new svs.components.ProductBase({
        generalSettings: {
          branding: 'maltipset'
        },
        content: {
          gameColumn: {
            view: svs.maltipset.views.coupon,
            options: {
              grid: showWideCoupon ?
                  {
                    xs: 6,
                    sm: 6,
                    md: 6,
                    lg: 4,
                    xl: 4
                  } :
                  { xs: 6, sm: 6, md: 4, lg: 4, xl: 4 },
              multiSwiper: {
                nodeId: 'couponHolder',
                toSubtract: [
                  '#top-content',
                  '#campaign-flerp',
                  '.js-product-base-tabs-nav',
                  '#drawChooser'
                ]
              }
            }
          },
          contentColumn: {
            options: {
              grid: showWideCoupon ?
                  {
                    xs: 6,
                    sm: 6,
                    md: 6,
                    lg: 8,
                    xl: 8
                  } :
                  { xs: 6, sm: 6, md: 8, lg: 8, xl: 8 }
            }
          }
        },
        tabs: svs.maltipset.data.config.startPageConfig ?
            svs.maltipset.data.config.startPageConfig.tabs :
            []
      });

      this.getRegion('game').show(productBase);
      this.productBaseGame = productBase.$el.find('#game-column');
      this.productBaseContent = productBase.$el.find('#content-column');

      svs.maltipset.multiSwiper = productBase.getMultiSwiper();
      svs.maltipset.productBase = productBase;
      if (productBase) {
        productBase.on('tabChanged', function() {
          self.oldQuerystring = null;
          self.clearSelectedMatch();
          svs.components.sportinfo.bigstat.unmountBigStat(document.getElementById('content-column'));
        });
      }

      svs.maltipset.controllers.maltipsetController.showBetslip(coupon);

      this.$el.toggleClass(
        'system-active',
        coupon.isMOrRSystem() || coupon.get('xpertBaseRowMode')
      );

      $('body').addClass('bg-maltipset-400 body-overflow-hidden');

      if (!svs.maltipset.multiSwiper) {
        this.setupMultiSwiper();
      }

      svs.maltipset.multiSwiper.updateSize();

      var swiper = $('.js-swiper-container').has('#coupon');
      var playContent = $('.maltipset-play-content');
      var targetOffset = playContent.offset().top - swiper.offset().top;
      var checkPosition = _.debounce(function() {
        if (swiper.scrollTop() > targetOffset) {
          playContent.css({
            position: 'static'
          });
        } else {
          playContent.css({
            position: 'relative'
          });
        }
      }, 100);
      swiper.on('scroll', checkPosition);

      var urlEventNumber;
      if (window.location.pathname.split('/').length > 3) {
        urlEventNumber = parseInt(window.location.pathname.split('/')[3].split('-')[0], 10);
      }
      if (urlEventNumber) {
        this.showStatsForMatch(coupon);
      }
    },

    onAttach: function() {
      if (
        svs.maltipset.collections.draws &&
        svs.maltipset.collections.draws.any()
      ) {
        this.initProductBase();
      } else {
        svs.maltipset.views.skeletonCoupon = new svs.maltipset.views.SkeletonCoupon();
        var productBase = new svs.components.ProductBase({
          generalSettings: {
            branding: 'maltipset'
          },
          content: {
            gameColumn: {
              view: svs.maltipset.views.skeletonCoupon,
              options: {
                grid: {
                  xs: 6,
                  sm: 6,
                  md: 5,
                  lg: 4,
                  xl: 4
                }
              }
            },
            contentColumn: {
              options: {
                grid: {
                  xs: 6,
                  sm: 6,
                  md: 7,
                  lg: 8,
                  xl: 8
                }
              }
            }
          },
          tabs: svs.maltipset.data.config.startPageConfig.tabs
        });

        this.getRegion('game').show(productBase);
      }
    },
    changeCouponWidth: function() {
      var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
      if (coupon.isMOrRSystem() || coupon.get('xpertBaseRowMode')) {
        this.$el.addClass('system-active');
        this.productBaseContent
          .removeClass('col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8')
          .addClass('col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8');
        this.productBaseGame
          .removeClass('col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4')
          .addClass('col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4');
      } else {
        this.$el.removeClass('system-active');
        this.productBaseContent
          .removeClass('col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8')
          .addClass('col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8');
        this.productBaseGame
          .removeClass('col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4')
          .addClass('col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4');
      }
    },

    showStatsForMatch: function(coupon, match) {
      var currentCoupon =
          coupon || svs.maltipset.collections.coupons.getCurrentCoupon();

      var drawNumber = svs.maltipset.collections.draws.models[
        svs.maltipset.collections.draws.currentDrawIndex
      ].get('drawNumber');

      var newSelectedMatch = Boolean(match);

      var urlEventNumber;
      if (window.location.pathname.split('/').length > 3) {
        urlEventNumber = parseInt(window.location.pathname.split('/')[3].split('-')[0], 10);
      }
      var matchList = svs.maltipset.collections.draws.models[
        svs.maltipset.collections.draws.currentDrawIndex
      ].get('matchList').models;

      for (var i = 0; i < matchList.length; i++) {
        if (matchList[i].get('eventNumber') == urlEventNumber) {
          if (match == undefined) {
            match = matchList[i];
          }
        }
      }
      match.set('isSelected', true);

      var selectedMatch = match || currentCoupon.get('selectedMatch');

      var url =
        '/' +
        drawNumber +
        '/' +
        selectedMatch.get('eventNumber');

      var eventDescription = selectedMatch
        .get('eventDescription')
        .replace(/ /g, '');

      var productId;
      this.bigstatController = new svs.maltipset.controllers.BigStatController();

      productId = svs.maltipset.collections.draws.models[
        svs.maltipset.collections.draws.currentDrawIndex
      ].get('productId');

      svs.core.data.title = svs.core.data.title || {};
      if (eventDescription) {
        svs.core.data.title = _.extend(svs.core.data.title, {
          eventDescription: eventDescription
        });
        url += '-' + svs.utils.url.encode(eventDescription);
      }

      if (newSelectedMatch) {
        var tab = Backbone.history.location.pathname.match(new RegExp(Object.values(svs.components.sportinfo.common.constants.SportinfoPathNames).join('|') + '$', 'i'));
        tab = tab ? '/' + tab[0] : '';
        svs.maltipset.router.navigate(url + tab, { trigger: true, replace: svs.core.detect.formfactor.desktop() });
      }
      if (selectedMatch && drawNumber && matchList && productId) {
        this.bigstatController.showBigNav({
          match: selectedMatch.get('match'),
          drawNumber: drawNumber,
          productId: productId,
          matchList: matchList
        });
      }
    },

    clearSelectedMatch: function() {
      var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
      var drawNum = coupon.get('draw').get('drawNumber');
      coupon.set('selectedMatch', null, { silent: true });

      svs.maltipset.router.navigate(
        '/' + drawNum + (self.oldQuerystring || window.location.search),
        { trigger: true, replace: false }
      );
      var matchList = svs.maltipset.collections.draws.models[
        svs.maltipset.collections.draws.currentDrawIndex
      ].get('matchList').models;

      for (var i = 0; i < matchList.length; i++) {
        matchList[i].set('isSelected', false);
      }
      this.productBaseGame.find('.maltipset-match-row').removeClass('selected');
      self.oldQuerystring = null;
    },

    onDestroy: function() {
      svs.maltipset.controllers.maltipsetController.hideBetslip();
      $('body').removeClass('bg-maltipset-400 body-overflow-hidden');
      svs.maltipset.multiSwiper.destroyAllSwipers();
      svs.maltipset.multiSwiper = undefined;
    },

    setupMultiSwiper: function() {
      var multiSwiperOptions = {
        scrollerOptions: [
          {
            nodeId: 'couponHolder',
            toSubtract: [
              '#top-content',
              '#campaign-flerp',
              'js-product-base-tabs-nav',
              '#drawChooser'
            ]
          }
        ]
      };

      svs.maltipset.multiSwiper = svs.maltipset.multiSwiper ?
        svs.maltipset.multiSwiper :
        new svs.components.MultiSwiper(multiSwiperOptions);
      svs.maltipset.multiSwiper.init();
    },
    updateSwiper: function() {
      svs.maltipset.multiSwiper.updateSize();
    },
    addDrawSelector: function() {
      var drawselectorOptions = {
        callback: function(drawNum) {
          Backbone.history.navigate('spela/' + drawNum, {
            trigger: true,
            replace: true
          });
        },
        draws: svs.maltipset.collections.draws.getAllDraws(),
        currentDraw: svs.maltipset.collections.coupons
          .getCurrentCoupon()
          .get('draw')
          .get('drawNumber'),
        branding: 'maltipset',
        swiperUpdateFunction: this.updateSwiper
      };
      this.getRegion('drawSelector').show(new svs.sport.drawselector.views.Drawselector(drawselectorOptions));
    }
  });
})(Backbone, _, svs);


 })(window);